<ng-container *adaptLoading="!isInitialised">
    <dx-select-box class="h-100"
                   [width]="(isMobile$ | async) ? '90vw' : 420"
                   [items]="canvases"
                   [displayExpr]="canvasDisplayExpr"
                   [value]="canvas"
                   (valueChange)="canvasChange.emit($event)"> </dx-select-box>
</ng-container>
